import { FC, memo } from "react";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { EmptyState } from "@/components/ui/EmptyState";

/**
 * Empty state shown when filters return no results.
 */
export const CompaniesEmptyState: FC = memo(function CompaniesEmptyState() {
  return (
    <EmptyState
      icon={SearchOffIcon}
      title="No companies match your criteria"
      description="Your current filter combination returned no results. Try removing some filters or adjusting your ranges."
    />
  );
});

/**
 * Error state shown when data fetching fails.
 */
export const CompaniesErrorState: FC = memo(function CompaniesErrorState() {
  return (
    <EmptyState
      icon={ErrorOutlineIcon}
      title="Unable to load companies"
      description="Something went wrong while fetching the data. Please try again or contact support if the problem persists."
      variant="error"
    />
  );
});
